import $ from 'jquery';
import { TweenMax } from 'gsap';

export default () => {

    $(document).ready(function () {

        $('.main-menu__hamburger').css({ 'margin-top': '-' + $('.main-menu__hamburger').outerHeight() });
        var $menu_height = '-' + $('.main-menu__hamburger').outerHeight();

        // == FIX ==
        $('.main-menu__hamburger').attr('style', 'max-height: 100vh; overflow-y: auto; overflow-x: hidden; margin-top: ' + $menu_height + 'px');

        var $curr = $('.current_page_ancestor');
        var $currClass = 'header-current-menu';
        if ($curr.length === 0) {
            $curr = $('.current-menu-item');
        }

        var $currentOpen = $('header .main-menu__main-menu__submenu .' + $curr.attr('id'));
        var $currentHOme = $('header .section-switcher').find($curr.find('a')).attr('href');
        $curr.addClass($currClass);
        if ($(window).width() <= 800) {
            $currentOpen = $('.menu-second-child .' + $curr.attr('id'));
            $currentHOme = $('.section-switcher-mobile').find($curr.find('a')).attr('href');
            $currentOpen.show();
        }

        if (!$currentOpen.length > 0) {
            $currentOpen = $('.' + $('.section-switcher li:first-child').attr('id'));
            $('.section-switcher li:first-child').addClass('header-current-menu');
        }

        $('.sparkasse-loghi a').attr('href', $currentHOme);


        if ($(window).width() > 800) {
            $currentOpen.addClass('flagged-active');
        }
        else {
            $currentOpen.addClass('current-menu-item');
        }

        //init breadcrumb link home in base alla sezione in cui sono
        $('.back-to-home').attr('href', $currentHOme);

        //----------
        //add to body the class of current section privati/imprese
        var currentSectionClass = $('.section-switcher').find('.header-current-menu').attr('class');
        var currentSection = '';
        if (currentSectionClass !== undefined) {
            if (currentSectionClass.indexOf('page-section-1') !== -1) {
                currentSection = 'page-section-privati-famiglie';
                $('.box-show-privati-famiglie').show();
                $('.box-show-imprese').hide();
                $('.box-show-imprese-mobile').hide();
            }
            else if (currentSectionClass.indexOf('page-section-2') !== -1) {
                currentSection = 'page-section-imprese';
                $('.box-show-privati-famiglie').hide();
                $('.box-show-imprese').show();
                $('.box-show-imprese-mobile').hide();
                if ($(window).width() <= 768) {
                    $('.box-show-imprese').hide();
                    $('.box-show-imprese-desktop').show();
                    $('.box-show-imprese-mobile').show();
                }
            }
        }
        // console.log(currentSection);
        $('body').addClass(currentSection);
        //----------

        $('.main-menu__main-menu__burger-button, .main-menu__main-menu__search, .main-menu__main-menu__login').click(function () {

            set_preferred_login();

            $('.background-menu').fadeIn();
            $('.main-menu-container > div').removeClass('active-menu');

            if ($(this).hasClass('main-menu__main-menu__burger-button')) {
                $('.main-menu-container__burger').addClass('active-menu');
            }

            $('.nav-icon-burger').addClass('open-menu');
            $('body').css('overflow', 'hidden');

            if ($('.nav-icon-burger').hasClass('open-menu')) {
                $('.main-menu__hamburger').animate({ 'margin-top': 0 }, 200);
            }

            if ($(this).hasClass('main-menu__main-menu__search')) {
                $('.main-menu-container__search').addClass('active-menu');
                // $('.nav-icon-burger').removeClass('open');
            }
            if ($(this).hasClass('main-menu__main-menu__login')) {
                $('.main-menu-container__login').addClass('active-menu');
                // $('.nav-icon-burger').removeClass('open');
            }
            show_hide_logo_header();
        });


        $('.close-menu, .background-menu').click(function () {

            $('.background-menu').fadeOut();
            var $menu_height = '-' + $('.main-menu__hamburger').outerHeight();
            $('.main-menu__hamburger').animate({ 'margin-top': $menu_height }, 200);
            $('body').css('overflow-y', 'auto');
            $('.nav-icon-burger').removeClass('open-menu');
            show_hide_logo_header();
        });

        site_margin_top();

        /* MODIFICA STRUTTURA MENU PRINCIPALE HAMBURGER */
        if ($(window).width() > 800) {
            $('._menu-block-mobile').remove();
        } else {
            $('._menu-block-desktop').remove();
        }
    });

    $(document).scroll(function () {
        show_hide_logo_header();
    });

    $(window).resize(function () {
        site_margin_top();
    });

    function site_margin_top() {
        if ($(window).width() > 800) {

            $('section#main').css('margin-top', $('.section-switcher').height() + $('.main-menu__main-menu').height());
        } else {
            $('section#main').css('margin-top', $('.main-menu-mobile__content').height());
        }
    }

    function show_hide_logo_header() {

        if ($(window).width() > 800) {
            if (($(document).scrollTop() >= 1) || ($('.nav-icon-burger').hasClass('open-menu'))) {

                TweenMax.staggerTo('.sparkasse-logo', 0.2, { y: -100, x: -100 }, 1);

                TweenMax.staggerTo('.sparkasse-loghi', 0.2, { width: '4.375rem' }, 1);

                TweenMax.staggerTo('.sparkasse-logo-pittogramma', 0.2, { left: 0, opacity: 1 }, 1);

                if ($(window).width() >= 1290) {

                    TweenMax.staggerTo('.main-menu__main-menu', 0.2, { padding: '0 6.25rem' }, 1);
                } else {
                    TweenMax.staggerTo('.main-menu__main-menu', 0.2, { padding: '0' }, 1);
                }

            } else {

                TweenMax.staggerTo('.sparkasse-logo', 0.2, { y: 0, x: 0 }, 1);

                TweenMax.staggerTo('.sparkasse-loghi', 0.2, { width: $('.sparkasse-logo img').outerWidth() + 40 }, 1);

                TweenMax.staggerTo('.main-menu__main-menu', 0.2, { padding: '0' }, 1);

                TweenMax.staggerTo('.sparkasse-logo-pittogramma', 0.2, { left: '500px', opacity: 0 }, 1);

            }
        }
    }


    /*
     Mobile menu nav left
     */

    $('.main-menu-mobile__main-menu__burger-button').click(function () {

        close_right_menu();

        if ($('.nav-icon-burger').hasClass('open')) {
            remove_fixed_body();
            $('.background-menu').fadeOut();
        }
        else {
            fix_body();
            $('.background-menu').fadeIn();
        }

        $('.nav-icon-burger').toggleClass('open');

        $('.slide-menu').width($(window).width() - $('.main-menu-mobile__main-menu__burger-button').outerWidth() + 15);
        $('.slide-menu').height($(window).height());


        if ($('.nav-icon-burger').hasClass('open')) {

            TweenMax.staggerTo('.main-menu-mobile__content', 0.2, { x: $(window).width() - $('.main-menu-mobile__main-menu__burger-button').outerWidth() }, 1);

            TweenMax.staggerTo('.slide-menu', 0.2, { left: 0 }, 1);

        } else {

            TweenMax.staggerTo('.main-menu-mobile__content', 0.2, { x: 0 }, 1);

            TweenMax.staggerTo('.slide-menu', 0.2, { left: '-100%' }, 1);

            $('.submenu-slider > ul > li').hide();
            TweenMax.staggerTo('.submenu-slider', 0.2, { 'left': '-100%' }, 0.1);
        }

    });

    function fix_body() {
        $('body').addClass('fixedbody');
    }

    function remove_fixed_body() {
        $('body').removeClass('fixedbody');
    }

    $('.main-menu-mobile__hamburger--first li, .main-menu-mobile__hamburger--second li').on('click', function () {

        var menuClicked = $(this).attr('class');
        var res = menuClicked.split(' ');
        var menuSelected = $('.submenu-slider .' + res[res.length - 1]);

        menuSelected.show();

        TweenMax.staggerTo('.submenu-slider', 0.2, { 'left': '0' }, 0.1);

    });

    $('.submenu-slider > ul > li').on('click', function () {
        $('.submenu-slider > ul > li').hide();
        TweenMax.staggerTo('.submenu-slider', 0.2, { 'left': '-100%' }, 0.1);

    });


    /*
     Mobile menu nav right
     */

    $('.main-menu-mobile__main-menu__search, .main-menu-mobile__main-menu__isi').click(function () {

        fix_body();
        $('.background-menu').fadeIn();

        $('.main-menu-mobile__main-menu__search-content, .main-menu-mobile__main-menu__isi-content').removeClass('display-block');
        var classAttr = $(this).attr('class'),
            classAttrSplit = classAttr.split(' ');

        var showMenu = classAttrSplit[0] + '-content';

        $('.' + showMenu).addClass('display-block');


        $('.slide-menu-right').width($(window).width() - $('.main-menu-mobile__main-menu__burger-button').outerWidth());
        //$('.slide-menu-right').height($(window).height());

        TweenMax.staggerTo('.slide-menu-right', 0.2, { 'left': '0', x: $('.main-menu-mobile__main-menu__burger-button').outerWidth() }, 1);

        TweenMax.staggerTo('.scroll-top-effect', 0.2, { y: -100 }, 0);

        set_preferred_login();
    });


    $('#exampleAccordionDesktop').on('show.bs.collapse', function (e) {
        e = e || window.event;
        var current_login = $(e.target).attr('class');
        current_login = current_login.replace('collapse', '').replace('show', '').replace('collapsing', '').trim();
        save_preferred_login(current_login);
    });

    $('#exampleAccordionMobile').on('show.bs.collapse', function (e) {
        e = e || window.event;
        var current_login = $(e.target).attr('class');
        current_login = current_login.replace('collapse', '').replace('show', '').replace('collapsing', '').trim();
        navigateToElement(current_login);
        save_preferred_login(current_login);
    });

    function save_preferred_login(current_login) {
        localStorage.setItem('preferred_login_type', current_login);
    }

    function navigateToElement(item) {
        setTimeout(function () {
            var offset = $('#exampleAccordionMobile .' + item).attr('data-scroll');
            $('.slide-menu-right__container').animate({ scrollTop: offset }, 500);

            var list_input = $('#exampleAccordionMobile .' + item + ' input');
            $(list_input[0]).focus();
        }, 500);
    }

    function set_preferred_login() {
        var preferred_login = localStorage.getItem('preferred_login_type');
        ////console.log(preferred_login);
        if (preferred_login != undefined) {
            jQuery('.' + preferred_login).addClass('show');
            navigateToElement(preferred_login);
        }
    }

    $('.slide-menu-right__close').click(function () {
        remove_fixed_body();
        close_right_menu();
        $('.background-menu').fadeOut();

    });

    function close_right_menu() {
        TweenMax.staggerTo('.slide-menu-right', 0.2, { 'left': '100%' }, 1);

        TweenMax.staggerTo('.scroll-top-effect', 0.2, { y: 0 }, 0);
    }

};



// WEBPACK FOOTER //
// ./scripts/nav-menu.js